import React from "react";
import NoDataPage from "../../../NoDataPages/NoDataPage";
import startService from "../../../../assets/images/OPImages/startService.svg";
import { Col, Row } from "antd";
import { checkEmpty } from "../../../../helpers/utility";
import DisplaySummary from "./DisplaySummary";

const OPSummary = ({ currentEmr, refreshPage, hideEdit, patientData }) => {
  return checkEmpty(currentEmr) ? (
    <div style={{ marginLeft: 0 }}>
      <DisplaySummary
        currentEmr={currentEmr}
        refreshPage={refreshPage}
        hideEdit={hideEdit}
        patientData={patientData}
      />
    </div>
  ) : (
    <Row
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Col span={24} style={{ textAlign: "center" }}>
        <NoDataPage
          subtitle="Click the 'Start Service' button to begin."
          image={startService}
        />
      </Col>
    </Row>
  );
};

export default OPSummary;
